import { TabsProps } from "@/common/components/Tabs";
import { MaintenaceWorkflowData } from "@/features/privateCompanies/types/maintenance/workflows/maintenanceWorkflows.type";
import { createElement } from "react";
import MaintenanceDescription from "../components/tabs/MaintenanceDescription";
import { maintenanceForwardingsDirectiveEntryKlasses } from "../constants/maintenanceForwardingsDirectiveEntryKlasses.constant";
import { MaintenanceForwardingsDirectiveEntryKlass } from "../features/forwardings/types/maintenanceForwardingsDirectiveEntryKlasses.type";
import MaintenanceWorkflowForwardingsTab from "../components/tabs/ForwardingsTabs";

export const getWorkflowTabsList = (
  workflow: MaintenaceWorkflowData | undefined,
  forwardingsDirectiveEntryKlasses: MaintenanceForwardingsDirectiveEntryKlass[] | undefined,
) => {
  let forwardingsDirectiveEntryKlassesTabs: TabsProps['tabsList'] = [];

  if (forwardingsDirectiveEntryKlasses) {
    forwardingsDirectiveEntryKlassesTabs = forwardingsDirectiveEntryKlasses.map((directiveEntryKlass) => {
      const tab = maintenanceForwardingsDirectiveEntryKlasses[directiveEntryKlass];

      if (!tab) {
        return false;
      }

      return {
        value: directiveEntryKlass,
        label: tab.label,
        body: createElement(MaintenanceWorkflowForwardingsTab, {
          workflow,
          directiveEntryKlass,
        }),
        operationKlassToCheckPermission: 'Admin::Maintenance::Workflows::FilterForwardings',
      };
    }).filter(tab => tab) as TabsProps['tabsList'];
  }

  return [
    {
      label: 'Descrição da manutenção',
      value: '',
      body: createElement(MaintenanceDescription, { workflow }),
    },
    ...forwardingsDirectiveEntryKlassesTabs,
  ] as TabsProps['tabsList'];
}
